<template>
  <ComponentLayout
    id="edit-criteria-card"
    content_class="pr-8"
    fluid_main_container
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        class="pt-1"
        :dialog.sync="opened"
        without_top_padding/>
    </template>
    <template #main_content>
      <div class="width-100">
        <div class="pt-1 h1-headline text-left">
          {{ $t('Tenders.EditNonPriceCriteria') }}
        </div>
        <div class="h4-headline pb-4 pt-1 text-start">
          {{ $t('Tenders.AddedCriteria') }}
        </div>
        <div>
          <v-skeleton-loader
            v-if="loading"
            :boilerplate="false"
            class="mt-4"
            :tile="false"
            type=" table-thead, table-tbody, table-tbody"
            width="100%"/>
          <CriteriaTable
            v-else
            :bidding_type="bidding_type"
            :card="card"
            class="main__light_green"
            editable
            :error_fields="error_fields"
            :has_empty_fields="has_empty_fields"
            :items="card.criterias"
            :tender="tenderComputed"/>
        </div>
        <div class="flex py-2">
          <sButton
            class="h11-links-bold"
            data-qa="add-criterion"
            icon="plus"
            icon-size="10px"
            small
            type="text"
            @click="addCriterion">
            {{ $t('Tenders.ToAddCriterion') }}
          </sButton>
        </div>
      </div>
      <div
        v-if="reducedPriceAvailable"
        class="width-100">
        <div class="h1-headline pb-3 pt-4 text-left">
          {{ forPercentage ? $t('Tenders.SetGivenScore') : $t('Tenders.SetGivenPrice') }}
        </div>
        <div
          class="pa-10 flex flex-between main__light_green"
          data-qa="given-price">
          <div cols="7">
            <RadioGroup
              class-name="mt-2 py-0"
              data-qa="given-price-radio"
              :header="`${forPercentage ? $t('Tenders.TenderWithGivenScore') : $t('Tenders.TenderWithGivenPrice')}?`"
              :model.sync="card.useReducedPrice"
              row/>
            <ChangeGivenPrice
              v-if="card.useReducedPrice"
              ref="given_price"
              :card="card"
              :criteria="card.criterias"
              :variables.sync="variables"
              @changeToStandart="useStandardReducedPrice"
              @updateFormula="updateFormula"/>
          </div>
          <div
            class="flex flex-right flex-align-top flex-wrap ml-4"
            style="width: 240px;">
            <sAlert
              v-if="bidding_type.isMultistage"
              type="warning">
              <template slot="desc">
                {{ $t('Tenders.HintRecalcPrice') }}
              </template>
            </sAlert>
            <sAlert>
              {{ forPercentage ? $t('Tenders.WhatGivenScore') : $t('Tenders.WhatGivenPrice') }}
              <template slot="desc">
                {{ forPercentage ? $t('Tenders.GivenScoreText') : (read_more ? $t('Tenders.GivenPriceTextFull') : $t('Tenders.GivenPriceText')) }}
                <sButton
                  v-if="!forPercentage && !read_more"
                  class="text-decoration-underline text-capitalize mt-4 h7-text"
                  small
                  type="text"
                  @click="() => read_more = true">
                  {{ $t('Tenders.ReadMore') }}
                </sButton>
              </template>
            </sAlert>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <CreateTenderFooter
        key="footer"
        :check-chages="() => {}"
        :next_btn="!changedCard && !!card_code"
        :next_disable="next_disable"
        @backStep="$emit('backStep')"
        @nextStep="$emit('nextStep')">
        <template #back>
          <sButton
            type="text"
            @click="backFunc">
            <sIcon
              class="s-btn-icon"
              rotate="90"
              size="10"
              type="long-arrow"/>
            {{ $t('Common.Back') }}
          </sButton>
        </template>
        <template #next="{ nextFunc, disableNext }">
          <WithoutCriteriaConfirmationDialog
            v-if="!card_code && !changedCard"
            :disabled="disableNext"
            :next-func="nextFunc"/>
          <SaveCriteriaAsTemplate
            v-else-if="changedCard"
            :card="card"
            :disabled="disableNext || next_disable"
            :next-func="() => {
              old_card = $_.cloneDeep(card)
              nextFunc()
            }"
            :open-func="beforeNext"
            :tender="tenderComputed"/>
        </template>
      </CreateTenderFooter>
    </template>
  </ComponentLayout>
</template>
<script>
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import CriteriaTable from 'components/tenders/critetia/CriteriaTable.vue'
import CreateTenderFooter from 'components/tenders/CreateTenderFooter.vue'
import ChangeGivenPrice from 'components/tenders/critetia/ChangeGivenPrice.vue'
import SaveCriteriaAsTemplate from 'components/tenders/critetia/SaveCriteriaAsTemplate.vue'
import WithoutCriteriaConfirmationDialog from 'components/tenders/critetia/WithoutCriteriaConfirmationDialog.vue'

import { mapGetters } from 'vuex'
import { beforeunloadMixin, criteriasMixin, modalMixin, functionRandom, tenderMixin } from 'mixins'
import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'editCriteriaCard',
  mixins: [ modalMixin, criteriasMixin, beforeunloadMixin, tenderMixin, functionRandom, godModeMixin],
  data() {
    const that = this
    return {
      card: {},
      old_card: {},
      loading: false,
      read_more: false,
      formula: '',
      variables: [],
      error_fields: false,
      default_row: {
        allowDecimals: false,
        attachmentMode: 'NOT_AVAILABLE',
        calculationFormula: '',
        criterionCode: '',
        criterionBindingLevel: null,
        criterionControlType: null,
        description: '',
        dictionaryValues: [],
        dynamicCriterions: [],
        fixedValue: '',
        formulaCode: '',
        measuringUnit: {},
        criterionKind: 'DEFAULT',
        isDisplayed: 'ALWAYS',
        isBestValueDisplayedWeb: false,
        maxValue: null,
        minValue: null,
        scoreDirection: 'MAX',
        standartValue: null,
        criteriaMark: '',
        title: null,
        useInRedFormula: false
      },
      formData: {
        items: [],
        reducedPrice: ''
      },
      rules: {
        reducedPrice: {
          validator (rule, value, callback) {
            if (!that.card.useReducedPrice) {
              callback()
            }
            if (that.card.useStandardReducedPrice) {
              // должен быть хотя бы 1 критерий по справочнику (который используется в формуле) с заполненным весом
              if (!that.card.criterias.some(el => el.criterionControlType == 'DICTIONARY')) {

                that.$notice.warning({
                  message: that.$t('Tenders.shouldLeastOneReferenceBookWithWeight'),
                  showClose: true,
                  progress: true,
                  duration: 20
                })
                callback(new Error())
              }
              // могут быть и другие справочники с незаполненным весом (это норм поведение). НО должен быть минимум 1 с заполненным весом (больше 0)
              if (!that.card.criterias.some(el => el.criterionControlType == 'DICTIONARY' && el.dictionaryValues.some(el => el.score))) {
                that.$notice.warning({
                  message: that.$t('Tenders.mustLeastOneReferenceWithWeight'),
                  showClose: true,
                  progress: true,
                  duration: 20
                })
                callback(new Error())
              }
              // сумма (вес) по всем критериям по справочнику (которые применяются в формуле) должен быть меньше 100 баллов
              let dictionaryValues = that.card.criterias.reduce((tot, item) => {
                if (item.criterionControlType == 'DICTIONARY') {
                  return tot + (item.dictionaryValues.length ? Math.max(...item.dictionaryValues.map(el => +el.score)) : 0)
                }
                return tot
              }, 0)
              if (dictionaryValues >= 100) {
                that.$notice.warning({
                  message: that.$t('Tenders.sumMustLess100'),
                  showClose: true,
                  progress: true,
                  duration: 20
                })
                callback(new Error())
              }
            }
            if (that.$refs.given_price.error) {
              that.$notice.warning({
                message: that.$t('Tenders.errorInFormula'),
                showClose: true,
                progress: true,
                duration: 20
              })
              callback(new Error())
            }
          }
        }
      }

    }
  },
  props: {
    dialog: Boolean,
    tender: {
      type: Object
    }
  },
  created() {
    this.setCard()
  },
  computed: {
    ...mapGetters({
      tenderGetten: 'getNewTender',
    }),
    isNewFlou() {
      return !!this.tender
    },
    tenderComputed: {
      get() {
        return this.isNewFlou ? this.tender : this.tenderGetten
      },
      set(newValue) {
        if (this.isNewFlou) {
          this.$emit('update:tender', newValue)
        } else {
          this.tenderGetten = newValue
        }
      }
    },
    opened: {
      get() {
        return this.dialog
      },
      set(val) {
        this.$emit('update:dialog', val)
      }
    },
    card_code: {
      get() {
        return this.tenderComputed.criteryCard
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.tenderComputed)
        result.criteryCard = newValue
        this.tenderComputed = result
      }
    },
    standart_formula_variables() {
      return [
        {
          variable: 'M',
          title: this.$t('Tenders.NumberOfNonPriceIndicators'),
        },
        {
          variable: 'Vn',
          title: this.$t('Tenders.ValueOfIndicator'),
        },
        {
          variable: 'Vmax',
          title: this.$t('Tenders.MaxValueOfEachNonPriceIndicators'),
        },
        {
          variable: 'PRICE',
          title: this.forPercentage ? `${this.$t('Tenders.PriceForPercentageOnLot')}, %` : this.$t('Tenders.PricePparticipantOnLot'),
        }
      ]
    },
    next_disable() {
      return !this.card.criterias || !this.card.criterias.length
    },
    criterias() {
      return this.card.criterias
    },
    has_empty_fields() {
      return  this.criterias?.some(el =>  !el.criterionControlType
        || !el.title
        || typeof el.criterionKind !== 'string' || !el.criterionKind
        || !el.attachmentMode
        || !el.isDisplayed || !el.criterionBindingLevel)
    },
    useReducedPrice() {
      return this.card.useReducedPrice
    },
    changedCard() {
      return !this.$_.isEqual(this.card, this.old_card)
    },
    bidding_type() {
      return this.tenderComputed.biddingType
    },
    reducedPriceAvailable() {
      return this.bidding_type?.reducedPriceAvailable
    },
    forPercentage() {
      return this.bidding_type?.tenderingForPercentage
    }
  },
  methods: {
    async setCard() {
      this.loading = true

      if (this.card_code) {
        await this.getItem()
      } else {
        this.card = {
          criterias: [],
          reducedPriceFormula: '',
          title: '',
          useReducedPrice: false,
          useStandardReducedPrice: false,
        }
        await this.addCriterion()
        this.old_card = this.$_.cloneDeep(this.card)
      }
      this.formData.items = this.$_.cloneDeep(this.card.criterias)

      if (this.card.useReducedPrice && this.card.reducedPriceFormula && !this.card.useStandardReducedPrice) {
        let variable = this.card.reducedPriceFormula?.match(/(?<variableName>[a-zA-Z]+\b)/g)
        this.variables = this.$_.uniq(variable)
        this.variables.map(el => this.card.criterias?.find(it => it.formulaCode == el))
      } else if (this.card.useReducedPrice && this.card.useStandardReducedPrice) {
        this.variables = this.standart_formula_variables.slice(0)
      }
      this.loading = false
      await this.$_getPropFromDBStorage(`criteria.${this.tenderComputed.tenderId}.${this.card.id}`, null)
        .then(async (saved) => {

          if (saved &&
          (
            !!this.$_.differenceWith(this.card, saved, this.$_.isEqual).length
            || !!this.$_.differenceWith(saved.criterias, this.card.criterias, this.$_.isEqual).length)
          ) {
            this.$Modal.confirm({
              title: this.$t('Tenders.YouHaveSavedChangesOfCriteriaCard'), //  todo texts
              content: this.$t('Tenders.DoYouWantToApplyThem'), //  todo texts
              closable: false,
              cancelText: this.$t('Common.Skip'),
              onOk: () => {
                this.card = this.$_.cloneDeep(saved)
                this.validateAllCriteria()
              },
            })
          }
        })
    },
    setRules() {

      let getCriteriaRules = (item, index) => {
        let pref = `items[${index}]`
        return {
          [`${pref}.title`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'title exit')
                if (!value) {
                  callback(new Error('empty'))
                }
              }
            },
            {
              trigger: 'input',
              validator: (rule, value, callback) => {
                this.$log(value, 'title input')
                let error = this.nameValidate(item)
                if (error) {
                  callback(new Error(error))
                }
              }
            }
          ],
          [`${pref}.formulaCode`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'variable exit')
                if (!value) {
                  callback(new Error('empty'))
                }
              }
            },
            {
              trigger: 'input',
              validator: (rule, value, callback) => {
                this.$log(value, 'variable input')
                let error // = this.formulaValidate(item)
                if (error) {
                  callback(new Error(error))
                }
              },
            },
          ],
          [`${pref}.calculationFormula`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'calculationFormula exit')
                if (!value) {
                  callback(new Error('empty'))
                }
              }
            },
            {
              trigger: 'input',
              validator: (rule, value, callback) => {
                this.$log(value, 'calculationFormula input')
                let error = this.calculationFormulaValidate(item)
                if (error) {
                  callback(new Error(error))
                }
              },
            },
          ],
          [`${pref}.criterionKind`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'criterionKind')
                if (!value || typeof value !== 'string') {
                  callback(new Error('empty'))
                }
              }
            },
          ],
          [`${pref}.criterionBindingLevel`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'criterionBindingLevel')
                if (!value) {
                  callback(new Error('empty'))
                }
              }
            },
          ],
          [`${pref}.attachmentMode`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'attachmentMode')
                if (!value) {
                  callback(new Error('empty'))
                }
                if (item.criterionKind !== 'DEFAULT' && value != 'NOT_AVAILABLE') {
                  this.$notice.warning({
                    message: this.$t('Tenders.notPossibleNestingAnalog'),
                    showClose: true,
                    progress: true,
                    duration: 20
                  })
                  callback(new Error())
                }
              }
            },
          ],
          [`${pref}.isDisplayed`]: [
            {
              trigger: 'exit',
              validator: (rule, value, callback) => {
                this.$log(value, 'isDisplayed')
                if (!value) {
                  callback(new Error('empty'))
                }
              }
            },
          ],

        }
      }
      this.card?.criterias?.forEach((item, index) => {
        this.rules = {
          ...this.rules,
          ...getCriteriaRules(item, index)
        }
      })
      this.$log(this.rules, this.card)
    },
    backFunc() {
      let submitExit = () => {
        this.opened = false
        this.error_fields = false
        this.card = {}
        this.$notice.closeAll()
        this.old_card = {}
      }
      submitExit()
    },
    chackRules() {
      let error = { message: '' }
      if (this.has_empty_fields) {
        this.error_fields = true
        error.message = this.$t('Tenders.YouMustFillVField')
        throw error
      }

      if (this.card.useReducedPrice) {
        if (this.card.useStandardReducedPrice) {
          if (!this.card.criterias.some(el => el.useInRedFormula)) {
            // Повинен бути використаний хоча б 1 критерій б стандартній формулі
            error.message = this.$t('Validate.AtLeast1CriterionInTheStandartFormula')
            throw error
          }

          // можем і не зайти
          // должен быть хотя бы 1 критерий по справочнику (который используется в формуле) с заполненным весом
          if (!this.card.criterias.some(el => el.criterionControlType == 'DICTIONARY')) {
            error.message = this.$t('Validate.AtLeast1CriterionLisWhichUsedInTheFormula')
            throw error
          }

          // могут быть и другие справочники с незаполненным весом (это норм поведение). НО должен быть минимум 1 с заполненным весом (больше 0)
          if (!this.card.criterias.some(el => el.useInRedFormula && el.criterionControlType == 'DICTIONARY' && el.dictionaryValues.some(el => el.score))) {
            error.message = this.$t('Validate.AtLeast1CriterionListTypeWithWeightGreaterThan') //todo текстовка
            throw error
          }
          // сумма (вес) по всем критериям по справочнику (которые применяются в формуле) должен быть меньше 100 баллов
          let dictionaryValues = this.card.criterias.reduce((tot, item) => {
            if (item.useInRedFormula &&  item.criterionControlType == 'DICTIONARY') {
              return tot + (item.dictionaryValues.length ? Math.max(...item.dictionaryValues.map(el => +el.score)) : 0)
            }
            return tot
          }, 0)
          if (dictionaryValues >= 100) {
            error.message = this.$t('Validate.SumWeightForAllCriteriaListTypeMustBeLessThan')
            throw error
          }
        } else if (!this.card.reducedPriceFormula) {
          this.$refs.given_price.$refs.formula_editor.$refs.add_formula.validateFormula(true)
          error.message = this.$t('Validate.FillInTheFormulaOfTheGivenPrice')
          throw error
        }

        if (this.$refs.given_price.error && !this.mixin_isGodMode) {
          error.message = this.$t('Validate.FormulaIsIncorrectCheckIfItIsFilledInCorrectly')
          throw error
        }

      }

      let condition_error = '',
        rows_error = this.card?.criterias?.some(el => {
          let error = !el.criterionControlType
          || !el.title
          ||  !el.criterionKind
          || !el.attachmentMode
          || !el.isDisplayed
          || !el.criterionBindingLevel
          || el.formulaError
          || el.titleError
          || (el.calculationFormulaError && el.calculationFormulaError != el.calculationFormula)
          condition_error = this.checkInValidAllDynamic(this.card?.criterias, el) // провірка коректності динамічних критеріїв
          const staticFormula = this.$_checkStaticFormula(el, this.card?.criterias)
          return error || condition_error || staticFormula
        })
      if (condition_error) {
        error.message = this.$t('Validate.ImpossibleConditionConfigureTheCriterionDisplayCondition')
        throw error
      }

      if (rows_error) {
        error.message = this.$t('Validate.IncorrectDataCheckEnteredData')
        throw error
      }
      if (this.card?.criterias?.some(el => el.criterionControlType == 'CALCULATED' && !el.calculationFormula)) {
        error.message = this.$t('Validate.SpecifyTheFormulaForFormulaCriterion')
        throw error
      }
    },
    async beforeNext() {
      this.chackRules()
      if (!this.$_.isEqual(this.card, this.old_card)) {
        this.card_code = await this.createorUpdateCriteriaCard({
          tender: this.tenderComputed,
          card: this.card,
          checkTenderBySettings: () => this.checkTenderBySettings(this.tenderComputed)
        })

        this.$_deletePropFromDBStorage(`criteria.${this.tenderComputed.tenderId}.${this.card.id}`)
        this.card.id = this.card_code
        this.$notice.closeAll()
      }
    },
    async getItem() {
      this.old_card = await this.$store.dispatch('infoAboutCriterionCard', this.card_code) || {}
      this.card = this.$_.cloneDeep(this.old_card)
      this.old_card.criterias?.forEach(el => {
        el.allowDecimals ||= !!el.decimals
        el.titleError = this.nameValidate(el)
        el.calculationFormulaError = this.calculationFormulaValidate(el)
      })
      this.card = this.$_.cloneDeep(this.old_card)
      if (!this.reducedPriceAvailable) {
        this.card.useReducedPrice = false
        this.card.useStandardReducedPrice = false
      }
      if (!this.bidding_type?.analogAvailable) {
        this.card.criterias?.forEach(el => {
          el.criterionKind = 'DEFAULT'
        })
      }
    },
    exitConfirmCondit() {
      return true
    },
    async addCriterion() {
      let guid = await this.$store.dispatch('getNewId')

      if (!this.card.criterias) {
        this.card.criterias = []
      }

      this.card.criterias.push({
        ...this.default_row,
        criteriaMark: guid,
        key: this.card.criterias?.length ? Math.max(...this.card.criterias.map(el => el.id || el.key)) + 1 : 1 })

    },
    updateFormula() {
      this.card.useStandardReducedPrice = false
    },
    useStandardReducedPrice(val) {
      if (val) {
        this.card.useStandardReducedPrice = true
        this.clearReducedFormula()
      }
    },
    clearReducedFormula() {
      this.card.reducedPriceFormula = ''
      this.card?.criterias?.forEach(el => el.useInRedFormula = false)
    }
  },
  watch: {
    useReducedPrice(val) {
      if (!val) {
        this.useStandardReducedPrice(val)
        this.clearReducedFormula()
      }
      this.checkAllCriteriasFormulas()

    }
  },
  components: {
    RadioGroup,
    CriteriaTable,
    ComponentLayout,
    ChangeGivenPrice,
    TenderBreadcrumbs,
    CreateTenderFooter,
    SaveCriteriaAsTemplate,
    WithoutCriteriaConfirmationDialog
  }
}
</script>
<style lang="scss">
#component-layout-edit-criteria-card {
  .v-list-item {
    min-height: 20px;
  }
  .v-input--selection-controls__input {
    margin-right: 4px;
    .v-icon {
      width: 20px;
      height: 20px;
      align-self: center;
    }
  }
}
</style>
